export default __webpack_public_path__ + "static/media/lgBox.bcdaa29e.svg";